<div class="container">
    <mat-card appearance="outlined">
      <mat-card-title>Upload spreadsheet to create subcategories</mat-card-title>
      <button mat-fab  (click)="downLoadFile()" [disabled] ="!isAdminGroupUser"  
       [ngClass]="isAdminGroupUser ? 'mat-mini-fab mat-accent' : 'mat-mini-fab mat-button-disabled'"
       color="accent" style="position:absolute;right:30px;top:8px;width:35px; height:35px;"   matTooltip="Download Sample File">
        <span class="mat-mdc-button-wrapper">
          <i   class="material-icons" style="font-size:30px;">download</i>
        </span>
      </button>
      <mat-card-subtitle></mat-card-subtitle>
      <mat-card-content>
        <div class="col-md-12 form-group">
        <div class="instruction-box">
          <ul class="instruction-list">
            <li>
              Upload spreadsheet to create <span class="highlight">subcategories</span> with <span class="highlight">categories</span>; maximum <span class="highlight">250 records</span> per upload.
            </li>
            <li>
              If a <span class="highlight">category</span> does not exist, the application will attempt to create it before creating the <span class="highlight">subcategory</span>.
            </li>
            <li>
              Only the <span class="highlight">first sheet</span> will be processed; reference sheets are for guidance only.
            </li>
            <li>
              Do not rename the <span class="highlight">sheet</span>; use only the <span class="highlight">first sheet</span> to enter subcategory data.
            </li>
            <li>
              Do not modify <span class="highlight">column names</span>; always download and use the latest <span class="highlight">sample file</span>.
            </li>
            <li>
              Use only values from the <span class="highlight">sample file</span> for <span class="highlight">Category</span>, <span class="highlight">Status</span>, and <span class="highlight">Type</span>; others will be rejected.
            </li>
            <li>
              If reference data is missing, contact the <span class="highlight">system administrator</span>.
            </li>
            <li>
              Click <span class="highlight">Download</span> to get the sample format. A result file will be downloaded after upload, showing success/failure.
            </li>
          </ul>
        </div>
        </div>
        <div class="row">
          <div class="col-md-12 form-group">
            <input type="file" class="form-control" [disabled] ="!isAdminGroupUser"  (change)="uploadedFile($event)" placeholder="Upload file">
          </div>
        </div>
        <div *ngIf="isLoaderResult"
          style="display:flex; justify-content:content; align-items:center; position:absolute; top:40%;left:35%">
          <mat-spinner color="warn"></mat-spinner>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
